module.exports = __webpack_public_path__ + "img/bus.651e5ab9.svg";